// src/Games/Games.js
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '../styles/Games/Games.css';

// SVG Icons
const GamepadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="6" y1="12" x2="10" y2="12" />
    <line x1="8" y1="10" x2="8" y2="14" />
    <line x1="15" y1="13" x2="15.01" y2="13" />
    <line x1="18" y1="11" x2="18.01" y2="11" />
    <rect x="2" y="6" width="20" height="12" rx="2" />
  </svg>
);

const PlayIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const UsersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const TrophyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </svg>
);

const ZapIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const TargetIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

const StarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const TrendingUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const ConstructionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="8" rx="1" />
    <path d="M17 14v7" />
    <path d="M7 14v7" />
    <path d="M17 3v3" />
    <path d="M7 3v3" />
    <path d="M10 14 2.3 6.3" />
    <path d="m14 6 7.7 7.7" />
    <path d="m8 6 8 8" />
  </svg>
);

const BrainIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" />
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" />
  </svg>
);

const BarChartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);

const SparklesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    <path d="M5 3v4" />
    <path d="M19 17v4" />
    <path d="M3 5h4" />
    <path d="M17 19h4" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const CoinsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="8" r="6" />
    <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
    <path d="M7 6h1v4" />
    <path d="m13 10 2-2" />
  </svg>
);

const HomeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const gamesCatalog = [
  {
    id: 'bimapath',
    title: 'BimaPath',
    description: 'Navigate the insurance choices maze. Make strategic decisions from application to claim while managing disclosures, agents, life events, and regulatory pathways.',
    status: 'live',
    path: '/games/bimapath',
    icon: '🛡️',
    color: '#0f9e8a',
    colorLight: '#e6f6f3',
    players: '1 Player',
    duration: '15-25 min',
    difficulty: 'Easy',
    category: 'Insurance Sim',
    rating: '4.9',
    plays: '2.4k',
    features: ['25-Year Simulation', 'IRA Pathway', 'AML/KYC', 'Product Comparison']
  },
  {
    id: 'actuarial-trivia',
    title: 'Actuarial Trivia',
    description: 'Test your knowledge across life, general insurance, pensions, and risk management. Compete for the highest score on the leaderboard.',
    status: 'coming-soon',
    path: '/games/actuarial-trivia',
    icon: '🧠',
    color: '#8b5cf6',
    colorLight: '#f3f0ff',
    players: '1-4 Players',
    duration: '10 min',
    difficulty: 'Hard',
    category: 'Quiz',
    rating: '—',
    plays: '—'
  },
  {
    id: 'risk-simulator',
    title: 'Risk Simulator',
    description: 'Run virtual insurance portfolios through catastrophic scenarios. Balance premiums, reserves, and reinsurance to keep your company solvent.',
    status: 'coming-soon',
    path: '/games/risk-simulator',
    icon: '📊',
    color: '#d4003f',
    colorLight: '#fce8ee',
    players: '1 Player',
    duration: '30 min',
    difficulty: 'Expert',
    category: 'Simulation',
    rating: '—',
    plays: '—'
  }
];

export default function Games() {
  const [animatedItems, setAnimatedItems] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  useEffect(() => {
    const timers = gamesCatalog.map((_, index) =>
      setTimeout(() => {
        setAnimatedItems(prev => [...prev, index]);
      }, 150 * index + 300)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  const filteredGames = activeFilter === 'all' 
    ? gamesCatalog 
    : gamesCatalog.filter(g => g.status === activeFilter);

  return (
    <div className="games-page">
      {/* Sticky Navigation Bar */}
      <nav className="games-nav">
        <div className="games-nav-inner">
          <Link to="/" className="games-nav-home">
            <HomeIcon />
            <span>Back to Home</span>
          </Link>
          <div className="games-nav-brand">
            <GamepadIcon />
            <span>Games Hub</span>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="games-hero">
        <div className="games-hero-grid" />
        
        {/* Floating particles */}
        <div className="games-particle games-particle-1" />
        <div className="games-particle games-particle-2" />
        <div className="games-particle games-particle-3" />
        <div className="games-particle games-particle-4" />
        <div className="games-particle games-particle-5" />
        <div className="games-particle games-particle-6" />

        <div className="games-hero-content">
          <div className="games-hero-badge">
            <GamepadIcon />
            <span>Interactive Learning Hub</span>
          </div>

          <h1 className="games-title">
            Actuarial <span className="games-title-accent">Games</span>
          </h1>

          <p className="games-subtitle">
            Learn through play. Our games transform complex actuarial and insurance concepts into 
            engaging, interactive experiences designed for students, professionals, and curious minds alike.
          </p>

          <div className="games-hero-stats">
            <div className="games-hero-stat">
              <span className="games-hero-stat-num">3</span>
              <span className="games-hero-stat-label">Games</span>
            </div>
            <div className="games-hero-stat">
              <span className="games-hero-stat-num">1</span>
              <span className="games-hero-stat-label">Live</span>
            </div>
            <div className="games-hero-stat">
              <span className="games-hero-stat-num">2.4k</span>
              <span className="games-hero-stat-label">Plays</span>
            </div>
            <div className="games-hero-stat">
              <span className="games-hero-stat-num">4.9</span>
              <span className="games-hero-stat-label">Avg Rating</span>
            </div>
          </div>
        </div>
      </div>

      <div className="games-container">
        {/* Filter Tabs */}
        <div className="games-filter-bar">
          <button 
            className={`games-filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
            onClick={() => setActiveFilter('all')}
          >
            All Games
          </button>
          <button 
            className={`games-filter-btn ${activeFilter === 'live' ? 'active' : ''}`}
            onClick={() => setActiveFilter('live')}
          >
            <ZapIcon /> Live Now
          </button>
          <button 
            className={`games-filter-btn ${activeFilter === 'coming-soon' ? 'active' : ''}`}
            onClick={() => setActiveFilter('coming-soon')}
          >
            <ConstructionIcon /> Coming Soon
          </button>
        </div>

        {/* Section Header */}
        <div className="games-section-header">
          <h2 className="games-section-title">
            <TargetIcon />
            Available Games
          </h2>
          <span className="games-section-count">{filteredGames.length} title{filteredGames.length !== 1 ? 's' : ''}</span>
        </div>

        {/* Game Cards Grid */}
        <div className="games-grid">
          {filteredGames.map((game, index) => (
            <div
              key={game.id}
              className={`game-card ${animatedItems.includes(index) ? 'animate-in' : ''} ${game.status === 'coming-soon' ? 'coming-soon-card' : ''}`}
              onMouseEnter={() => setHoveredCard(game.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* Color accent bar */}
              <div 
                className="game-card-accent-bar" 
                style={{ background: `linear-gradient(90deg, ${game.color}, ${game.color}88)` }} 
              />

              {/* Banner with icon */}
              <div 
                className="game-card-banner" 
                style={{ color: game.color, background: game.colorLight }}
              >
                <div className="game-card-banner-pattern" />
                <div 
                  className="game-card-icon-wrap"
                  style={{ 
                    borderColor: `${game.color}30`,
                    transform: hoveredCard === game.id ? 'scale(1.1) rotate(-4deg)' : 'scale(1) rotate(0deg)'
                  }}
                >
                  {game.icon}
                </div>

                {/* Status badge */}
                <span className={`game-status-badge ${game.status}`}>
                  {game.status === 'live' ? (
                    <><span className="live-dot" />Live Now</>
                  ) : 'Coming Soon'}
                </span>
              </div>

              {/* Card Body */}
              <div className="game-card-body">
                <h2 className="game-card-title">
                  {game.title}
                  {game.status === 'live' && (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={game.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </h2>

                <p className="game-card-description">{game.description}</p>

                {/* Feature tags for BimaPath */}
                {game.features && (
                  <div className="game-card-features">
                    {game.features.map((feat, i) => (
                      <span key={i} className="game-feature-tag">
                        <SparklesIcon />{feat}
                      </span>
                    ))}
                  </div>
                )}

                {/* Tags */}
                <div className="game-card-tags">
                  <span className="game-tag" style={{ background: game.colorLight, color: game.color }}>
                    <ShieldIcon />
                    {game.category}
                  </span>
                  <span className="game-tag">
                    <StarIcon />
                    {game.difficulty}
                  </span>
                  {game.status === 'live' && (
                    <span className="game-tag" style={{ background: 'var(--green-lt)', color: 'var(--green)' }}>
                      <TrendingUpIcon />
                      {game.plays} plays
                    </span>
                  )}
                </div>

                {/* Meta info */}
                <div className="game-card-meta">
                  <div className="game-meta-item">
                    <UsersIcon />
                    <div>
                      <span className="game-meta-label">Players</span>
                      <span className="game-meta-value">{game.players}</span>
                    </div>
                  </div>
                  <div className="game-meta-item">
                    <ClockIcon />
                    <div>
                      <span className="game-meta-label">Duration</span>
                      <span className="game-meta-value">{game.duration}</span>
                    </div>
                  </div>
                  <div className="game-meta-item">
                    <CoinsIcon />
                    <div>
                      <span className="game-meta-label">Rating</span>
                      <span className="game-meta-value">{game.rating}</span>
                    </div>
                  </div>
                </div>

                {/* CTA */}
                {game.status === 'live' ? (
                  <Link to={game.path} className="game-card-cta primary">
                    <PlayIcon />
                    <span>Play Now</span>
                  </Link>
                ) : (
                  <button className="game-card-cta disabled" disabled>
                    <ConstructionIcon />
                    <span>Coming Soon</span>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* BimaPath Highlight Banner */}
        <div className="games-bimapath-highlight">
          <div className="bimapath-highlight-content">
            <div className="bimapath-highlight-icon">🛡️</div>
            <div className="bimapath-highlight-text">
              <h3>Featured: BimaPath Insurance Simulator</h3>
              <p>Walk through 25 years of insurance decisions — from product selection and agent interactions to life events, claims, and the IRA consumer protection pathway. Built with real Kenyan insurance data and regulatory frameworks.</p>
              <div className="bimapath-highlight-stats">
                <span><strong>25</strong> Year Simulation</span>
                <span><strong>17</strong> Scenario Variants</span>
                <span><strong>4</strong> Product Paths</span>
                <span><strong>1</strong> Regulatory Pathway</span>
              </div>
            </div>
            <Link to="/games/bimapath" className="bimapath-highlight-cta">
              <PlayIcon />
              Start Simulation
            </Link>
          </div>
        </div>

        {/* Coming Soon Banner */}
        <div className="games-coming-soon-banner">
          <div className="coming-soon-content">
            <div className="coming-soon-icon-wrap">🚧</div>
            <h3>More Games in Development</h3>
            <p>
              We are building more interactive experiences to help you master actuarial and insurance concepts. 
              Follow us on LinkedIn for early access announcements and beta invites.
            </p>
            <div className="coming-soon-features">
              <span className="coming-soon-feature">
                <BrainIcon />
                AI-Powered Opponents
              </span>
              <span className="coming-soon-feature">
                <BarChartIcon />
                Live Leaderboards
              </span>
              <span className="coming-soon-feature">
                <SparklesIcon />
                Achievement System
              </span>
            </div>
          </div>
        </div>

        {/* Leaderboard Teaser */}
        <div className="games-leaderboard-teaser">
          <h3>
            <TrophyIcon />
            Leaderboard Preview
          </h3>
          <p>Compete with actuaries worldwide. Top performers earn exclusive badges and recognition.</p>
          <div className="leaderboard-preview">
            <div className="leaderboard-avatar gold">🥇</div>
            <div className="leaderboard-avatar silver">🥈</div>
            <div className="leaderboard-avatar bronze">🥉</div>
            <div className="leaderboard-avatar">4</div>
            <div className="leaderboard-avatar">5</div>
            <div className="leaderboard-avatar">6</div>
            <div className="leaderboard-avatar">7</div>
            <div className="leaderboard-avatar">8</div>
          </div>
        </div>
      </div>
    </div>
  );
}
